/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class IntegrationsService {
  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static confirmStudentPlan(requestBody?: { code: string }): CancelablePromise<{
    success: boolean;
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/integrations/github/confirm-student-plan',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
